import { Injectable } from '@angular/core';
import * as cryptLib from 'cryptlib';

@Injectable({
  providedIn: 'root'
})
export class EncryDecryService {

  readonly secretKey = 'BEELINE';
  readonly vector = "VOh0RTWmQlMkTO4=";
  readonly key = cryptLib.getHashSha256(this.secretKey, 32);
  constructor() { }

  Encrypt(unencrypted) {
    if (unencrypted) {
      return cryptLib.encrypt(unencrypted, this.key, this.vector);
    }
    else {
      return '';
    }
  }
  Decrypt(encrypted) {
    if (encrypted) {
      return cryptLib.decrypt(encrypted, this.key, this.vector);
    }
    else {
      return '';
    }
  }
}
